var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#whoami'),expression:"'#whoami'"}],staticClass:"scroller is-flex"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon is-large is-relative animated infinite heartBeat delay-5s slow"},[_c('i',{staticClass:"fas fa-3x fa-chevron-down"})])
}]

export { render, staticRenderFns }